module.exports = __webpack_public_path__ + "img/fi-rr-marker.b7ca5879.svg";